import { STATIC_ASSETS_PLACEHOLDER } from "../staticAssetsPlaceholder.js";
const images = {
    background_paper_light: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/windflower/background_paper_light.png`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/windflower/optimized/background_paper_light.webp`,
        width: 1920,
        height: 1080,
    },
    background_paper_light_small: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/windflower/background_paper_light_small.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/windflower/optimized/background_paper_light_small.webp`,
        width: 480,
        height: 270,
    },
    card_flowers_left: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/windflower/card_flowers_left.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/windflower/optimized/card_flowers_left.webp`,
        width: 224,
        height: 800,
    },
    card_flowers_right: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/windflower/card_flowers_right.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/windflower/optimized/card_flowers_right.webp`,
        width: 224,
        height: 800,
    },
    clip_tab_top_left_dark: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/windflower/clip_tab_top_left_dark.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/windflower/optimized/clip_tab_top_left_dark.webp`,
        width: 160,
        height: 160,
    },
    flowers_1: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/windflower/flowers_1.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/windflower/optimized/flowers_1.webp`,
        width: 1500,
        height: 1500,
    },
    flowers_2: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/windflower/flowers_2.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/windflower/optimized/flowers_2.webp`,
        width: 1500,
        height: 1500,
    },
};
const sceneTransition = {
    variant: "imageSequence",
    timing: { variant: "linear", durationSeconds: 1.5 },
    mask: {
        urlPrefix: {
            full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/common/mask/{i}.png`,
            preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/common/optimized/mask/{i}.png`,
        },
        frameCount: 42,
        zeroPad: 2,
    },
    overlay: {
        urlPrefix: {
            full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/common/overlay/{i}.png`,
            preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/common/optimized/overlay/{i}.png`,
        },
        frameCount: 42,
        zeroPad: 2,
    },
};
const greetingTemplate = {
    type: "typeOnGreeting",
    variant: "intro",
    secondsPerCharacter: 0.1,
    minimumMessageDisplayTimeSeconds: 3,
    showLogo: true,
    sharedMessageAssets: [
        {
            url: images["flowers_1"],
            style: {
                position: "absolute",
                right: 0,
                top: 0,
                height: "100%",
                width: "auto",
                // flipping so we can use the same image for the other side
                transform: "scaleX(-1)",
            },
        },
        {
            url: images["flowers_2"],
            style: {
                position: "absolute",
                left: 0,
                top: 0,
                height: "100%",
                width: "auto",
                // flipping so we can use the same image for the other side
                transform: "scaleX(-1)",
            },
        },
    ],
};
export const windflower = {
    version: 1,
    themeId: "windflower",
    name: "Windflower",
    endFadeDuration: 1,
    thumbnailFrame: 165,
    thumbnailUrl: `${STATIC_ASSETS_PLACEHOLDER}/compilations/theme-stills/windflower.webp`,
    background: [
        {
            variant: "image",
            src: images["background_paper_light"],
        },
    ],
    scenes: [
        {
            type: "textTransition",
            variant: "intro",
            leftImage: { url: images["flowers_1"] },
            rightImage: { url: images["flowers_2"] },
            title: {
                text: "name",
                fontFamily: "Quattrocento",
                fontSize: 240,
                fontWeight: "medium",
                letterSpacing: "normal",
                textColor: "#282828",
                transition: "squish-in",
            },
            subtitle1: {
                text: "date",
                fontFamily: "EB Garamond",
                fontSize: 50,
                fontWeight: "normal",
                letterSpacing: "widest",
                textColor: "#282828",
            },
            subtitle2: {
                text: "subheading",
                fontFamily: "EB Garamond",
                fontSize: 40,
                fontWeight: "thin",
                letterSpacing: "widest",
                textColor: "#282828",
            },
            durationSeconds: 8,
            faceCollage: {
                variant: "top-bottom-static",
                borderShape: "circle",
                colorFilter: "grayscale",
                startAtSeconds: 1,
                entrance: { variant: "zoom-in" },
            },
        },
        {
            ...greetingTemplate,
            variant: "intro",
        },
        {
            type: "clip-series-basic",
            showLogo: true,
        },
        {
            ...greetingTemplate,
            variant: "outro",
        },
        {
            type: "textTransition",
            variant: "outro",
            title: {
                text: "name",
                fontFamily: "Quattrocento",
                fontSize: 240,
                fontWeight: "medium",
                letterSpacing: "normal",
                textColor: "#282828",
                transition: "squish-in",
            },
            subtitle1: {
                text: "date",
                fontFamily: "EB Garamond",
                fontSize: 50,
                fontWeight: "normal",
                letterSpacing: "widest",
                textColor: "#282828",
            },
            durationSeconds: 5,
            outroVariant: "darkBlue",
        },
    ],
    styles: {
        textBox: {
            backgroundColor: "#fff",
            backgroundOpacity: 0.1,
            backgroundBlur: 2,
            textAlign: "center",
            textColor: "#282828",
            fontFamily: "EB Garamond",
            fontWeight: "normal",
            fontSize: 96,
            leading: 1.1,
            tracking: 0,
            custom: {
                textShadow: "0.5rem 0.5rem 0.5rem rgba(0,0,0,0.1)",
            },
        },
        clips: {
            textVariant: {
                variant: "image-stretch",
                color: "#ffffff",
                leftUrl: images["card_flowers_left"],
                center: {
                    variant: "repeat-x-y",
                    url: images["background_paper_light_small"],
                },
                rightUrl: images["card_flowers_right"],
                maxWidthPx: 600,
                textContainerStyleOverride: {
                    height: "18rem",
                    paddingLeft: "5rem",
                    paddingRight: "5rem",
                },
            },
            betweenTransition: sceneTransition,
            backgroundVariant: {
                variant: "image",
                images: [
                    [
                        {
                            url: images["flowers_1"],
                            zPosition: "below",
                            top: 0,
                            left: 0,
                            width: "auto",
                            height: "100%",
                        },
                        {
                            url: images["flowers_2"],
                            zPosition: "below",
                            top: 0,
                            right: 0,
                            width: "auto",
                            height: "100%",
                        },
                    ],
                    [
                        {
                            url: images["flowers_1"],
                            zPosition: "below",
                            transformations: ["flip-x"],
                            top: 0,
                            right: 0,
                            width: "auto",
                            height: "100%",
                        },
                        {
                            url: images["flowers_2"],
                            zPosition: "below",
                            transformations: ["flip-x"],
                            top: 0,
                            left: 0,
                            width: "auto",
                            height: "100%",
                        },
                    ],
                ],
            },
            title: {
                backgroundColor: "#fff",
                backgroundOpacity: 0.95,
                textColor: "#282828",
                fontFamily: "Quattrocento",
                fontWeight: "medium",
                fontSize: 80,
                nudge: 2,
                textTransform: "none",
            },
            subtitle: {
                backgroundColor: "#fff",
                backgroundOpacity: 0.95,
                textColor: "#282828",
                fontFamily: "EB Garamond",
                fontWeight: "light",
                fontSize: 33,
                nudge: 2,
                textTransform: "uppercase",
            },
            scaleFactor: 0.7,
            overlay: {
                variant: "corner",
                url: images["clip_tab_top_left_dark"].full,
                offsetUnit: "-1rem",
            },
        },
        watermark: {
            opacity: 0.8,
            margin: 32,
            enterTransition: {
                variant: "slide",
                direction: "from-right",
                timing: { variant: "linear", durationSeconds: 0.5 },
            },
            exitTransition: {
                variant: "slide",
                direction: "from-left",
                timing: { variant: "linear", durationSeconds: 0.5 },
            },
        },
        sceneTransition,
    },
    userInputFields: [
        {
            id: "name",
            type: "text",
            label: "Name of Couple",
            defaultValue: "",
            placeholder: "Jessica & David",
            required: true,
            min: 1,
            max: 50,
            preview: {
                sceneIndex: 0,
                frameOffset: 150,
            },
        },
        {
            id: "date",
            type: "date",
            label: "Wedding Date",
            defaultValue: "",
            placeholder: "Select a date",
            required: true,
            dateFormat: "MM | dd | yyyy",
            preview: {
                sceneIndex: 0,
                frameOffset: 150,
            },
        },
        {
            id: "subheading",
            type: "text",
            label: "Subheading",
            defaultValue: "Guest Book",
            min: 0,
            max: 35,
            preview: {
                sceneIndex: 0,
                frameOffset: 150,
            },
        },
    ],
};
